import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0094',
    ecrans: ['00-2']
});

